/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.15.527 on 2019-07-04 14:53:30.

import { EmbeddableResourceNames } from '@Components/mras/core';

export interface ExpandableHalResource {
    _embedded: [EmbeddableResourceNames, ResourceSupport[]];
}

export class ResourceSupport {
    links: Link[];
}

export class ExpandedHalResource extends ResourceSupport implements ExpandableHalResource {
    _embedded: [EmbeddableResourceNames, ResourceSupport[]];
    _links: Link[];
}

export class Resources<T> extends ResourceSupport {
    content: T[];
}

export class ExpandedHalResources<T> extends Resources<T> implements ExpandableHalResource {
    _embedded: [EmbeddableResourceNames, ResourceSupport[]];
    _links: Link[];
}

export class Link {
    deprecation: string;
    href: string;
    hreflang: string;
    media: string;
    rel: string;
    title: string;
    type: string;
}
